$(document).on('click', '.js-link', function (event) {

    if (event.preventDefault) {
        event.preventDefault()
    } else {
        event.returnValue = false
    }

    window.location = $(this).data('href');
});